// Las reglas de un VIDEO de referencia en una generación —
// ADR-2026-09-26-video-de-referencia-en-el-estudio-y-el-agente.
//
// Seedance 2 (calidad estándar) acepta un video de entrada de hasta 14 s y Seedance 2.5
// (profesional) de hasta 29 s: uno menos que la salida de cada uno, porque el proveedor
// lee el tope exacto como "más que el tope". De ahí las dos reglas del Estudio: un video
// de más de 14 s pasa la calidad a profesional solo; uno de más de 29 s no entra. Puro.

/** Hasta cuántos segundos de video de entrada acepta cada calidad. */
export const TOPE_ENTRADA_ESTANDAR_S = 14;
export const TOPE_ENTRADA_PROFESIONAL_S = 29;

export type VeredictoDeVideoDeReferencia =
  | {
      ok: true;
      /** La calidad que hace falta, o null si cualquiera sirve (o no se sabe la duración). */
      calidad: 'profesional' | null;
    }
  | { ok: false; motivo: string };

/** Qué hacer con un video de esa duración como referencia. `null` = duración desconocida. */
export function evaluarVideoDeReferencia(duracionSeg: number | null | undefined): VeredictoDeVideoDeReferencia {
  if (typeof duracionSeg !== 'number' || !Number.isFinite(duracionSeg) || duracionSeg <= 0) {
    return { ok: true, calidad: null };
  }
  if (duracionSeg > TOPE_ENTRADA_PROFESIONAL_S) {
    return {
      ok: false,
      motivo: `Ese video dura ${formatearSegundos(duracionSeg)} y como referencia entra hasta ${TOPE_ENTRADA_PROFESIONAL_S} s. Recortalo antes de usarlo.`,
    };
  }
  if (duracionSeg > TOPE_ENTRADA_ESTANDAR_S) return { ok: true, calidad: 'profesional' };
  return { ok: true, calidad: null };
}

/** ¿Este video necesita calidad profesional para entrar entero? */
export function pideProfesional(duracionSeg: number | null | undefined): boolean {
  const v = evaluarVideoDeReferencia(duracionSeg);
  return v.ok && v.calidad === 'profesional';
}

function formatearSegundos(s: number): string {
  const r = Math.round(s * 10) / 10;
  return `${Number.isInteger(r) ? r : r.toFixed(1)} s`;
}
